<template>
  <div class="tile">
    <div class="tile-name">{{ menuItem.name }}</div>
    <div class="tile-sublist">
      <div v-for="(subItem, index) in menuItem.menuSublist" :key="index">
        <div class="tile-sublist-item" @click="subItemClick(index)">
          <span>{{ subItem }} </span>
        </div>
        <div
          v-if="menuItem.breaks && menuItem.breaks.includes(index)"
          class="break"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    subItemClick(index) {
      this.$router.push({ name: this.menuItem.routerLinks[index] });
    },
  },
  props: ["menuItem"],
};
</script>
<style scoped>
.tile {
  height: calc((100vh - var(--header-height)) / 1.2);
  width: calc(100vw / 4);
  background-color: var(--off-background);
  cursor: default;
  overflow: auto;
  /*For scrollbar in Mozilla*/
  scrollbar-color: var(--off-background-selected) var(--off-background);
  scrollbar-width: auto;
  border: 2px solid var(--menu-text-color);
}
.tile::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}
.tile::-webkit-scrollbar-track {
  background-color: var(--off-background);
}
.tile::-webkit-scrollbar-thumb {
  background-color: var(--off-background-selected);
}
.tile-name {
  font-family: "Roboto Mono", monospace;
  color: var(--menu-text-color-hover);
  font-size: 2em;
  text-align: center;
  padding: 10px 0px;
  border-bottom: 1px solid var(--menu-text-color);
}
.tile-sublist {
  padding-bottom: 30px;
}
.tile-sublist-item {
  cursor: pointer;
  font-size: 1.3em;
  padding: 7px 0px;
  margin: 0px 3px;
  color: var(--menu-text-color);
}
.tile-sublist-item:hover {
  background-color: var(--off-background-selected);
}
.tile-sublist-item:hover span {
  color: var(--menu-text-color-hover);
}
.tile-sublist-item::before {
  content: "\2022";
  margin: 0px 5px;
  font-weight: 800;
}
.break {
  background-color: var(--menu-text-color);
  height: 3px;
  margin: 5px 0px;
}
@media (max-width: 1030px) {
  .tile {
    height: calc((100vh - var(--header-height) - 40px) / 1.5);
    width: calc((100vw - 50px) / 2);
  }
}
</style>